export default __webpack_public_path__ + "static/media/medical_icon.68d2bc1d.svg";